import Luggage from "@material-symbols/svg-500/rounded/luggage.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const LuggageIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Luggage });
	return <Icon />;
};

export default memo(LuggageIcon);
